import Form from './form.vue';

export default Form;
